/**
 * Created by Marcus Zhao on 12/01/2020
 * -------------------------------------
 */

import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { CompanyAction, ContactTemplateType, ControlId } from '../../../contact-dialog-new/contact-dialog.model';
import { ContactTemplateService } from '../../../contact-dialog-new/contact-template.service';

@Component({
    selector: 'tam-contact-label',
    templateUrl: './contact-label.component.html',
    styleUrls: ['./contact-label.component.scss'],
    standalone: false
})
export class ContactLabelComponent implements OnInit, OnDestroy {
    @Input() childConfig: any;
    config: any;
    content: string;
    isEmploymentCompany = false;
    private _destroySubscriptions: Array<Subscription> = [];
    constructor(private _contactTemplateService: ContactTemplateService) { }

    ngOnInit() {
        this._initData();
        if (this.config.action === ContactTemplateType.EditContact || this.config.isSignature) {
            this._initEditValue();
        }
    }

    ngOnDestroy() {
        this._destroySubscriptions.forEach(item => item.unsubscribe());
    }

    /**
   *init edit value
   *
   * @private
   * @memberof ContactInputComponent
   */
    private _initEditValue() {
        this.content = this.config.editValue;
        // this.changeValueSet(false);
    }

    /**
    * init data source
    * @private
    * @memberof ContactCombineDropdownInputComponent
    */
    private _initData() {
        this.config = this.childConfig.config;
        if (this.config.controlID === ControlId.EmploymentCompany) {
            this.isEmploymentCompany = true;
        }
        this._destroySubscriptions.push(
            this._contactTemplateService.actionSubject$.subscribe(action => {
                if (action.type === CompanyAction.ChangeCompany) {
                    this.content = action.payload.targetCompany.name;
                }
            }));
    }
}
